import { Badge } from '@chakra-ui/react';
import { activityColorSchemes } from '../../../constants/activityColorSchemes';
import { CompanyContactType, companyContactTypeLabels } from '../../../enums/crm/CompanyContactType';

export const GroupsOnlyTravellerBadge = () => {
  return (
    <Badge colorPalette={activityColorSchemes.group}>
      {companyContactTypeLabels[CompanyContactType.GroupsOnlyTraveller]}
    </Badge>
  );
};
